module.exports = __webpack_public_path__ + "img/telegram.4fc7bda3.png";